// extracted by mini-css-extract-plugin
export default {"max_wrapper":"WysiwygTextarea_max_wrapper__cU53R","textarea":"WysiwygTextarea_textarea__r04BH","error":"WysiwygTextarea_error__IU3A3"};